import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    DropZone,
    LegacyStack,
    Thumbnail,
    Text,
    Spinner,

} from '@shopify/polaris';
import { Modal } from '@mui/material';
import { NoteIcon } from '@shopify/polaris-icons';
import { toast } from 'react-toastify';
import { getAppOverViewDetails, saveconfigurationsApi, uploadImageApi } from '../../dev_services/developer/api';
import { cross } from '../../../assets';
import { useParams } from 'react-router-dom';
import { fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { useDispatch } from 'react-redux';

const DevUploadIcon: React.FC<DevUploadIconProps> = ({ open, onClose }) => {
    const [files, setFiles] = useState<File[]>([]);
    const [loading, setLoading] = useState(false); 
    const { appID } = useParams();
    const dispatch = useDispatch();

    const handleDropZoneDrop = useCallback(
        (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) =>
            setFiles((files) => [...files, ...acceptedFiles]),
        [],
    );


    const handleSaveIconClick = async () => {
        try {
            setLoading(true); 
            // console.log("Uploading image..."+files);
            // Call the uploadImageApi function with the files
            const response = await uploadImageApi(files);
            
            if(response){
                // console.log("Image upload response:", response); 
                // toast.success("Image uploaded successfully.");
               try{
                const appIconUrl = response; // Assuming 'response' contains the app_icon object with the app_id property
                const sendData = { 
                  app_icon: appIconUrl, // Assigning the app_id value to the app_icon property
                  app_id: appID // Assuming 'appID' is the ID of the app
                };
                ///save image on s3 bucket server
                const saveResponse = await saveconfigurationsApi(sendData);
                console.log(saveResponse)
                ///fect new update changes
                const responseUpdate = await getAppOverViewDetails(appID);
                const slugName = response.slug;
                localStorage.setItem('slug', slugName);
                dispatch(fetchDataSuccess(responseUpdate));
                onClose()
               }
               catch(error){
                toast.error("Image Not upload ");
               }
              

            }
            
        } catch (error) {
            console.error("Error uploading image:", error);
            toast.error("Error uploading image");
        }
        finally{
            setLoading(false); 
           }
    };

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    const fileUpload = !files.length && (
        <div style={{
            display: "ruby-text",
            paddingTop: "40px", fontFamily: "sfprobold",fontSize:"22px"
        }}>
            <Text variant="bodySm" as="h1">Upload Icon</Text>
        </div>
    );

    const uploadedFiles =
        files.length > 0 && (
            <>
                {files.map((file, index) => (
                    <LegacyStack alignment="center" key={index}>
                        <Thumbnail
                            size="small"
                            alt={file.name}
                            source={
                                validImageTypes.includes(file.type)
                                    ? window.URL.createObjectURL(file)
                                    : NoteIcon
                            }
                        />
                        <div>
                            {file.name}{' '}
                            <Text variant="bodySm" as="p">
                                {file.size} bytes
                            </Text>
                        </div>
                    </LegacyStack>
                ))}
            </>
        );

    
    return (
        <Modal  open={open} onClose={onClose}>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    outline: 'none',
                    borderRadius: '10px',
                    // Add relative positioning
                }}
            >
                {/* Position the close icon at the top-right corner */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        padding: '5px',
                    }}
                >
                    <img
                        style={{ width: '40px', cursor: 'pointer' }}
                        src={cross}
                        alt="Close Icon"
                        onClick={onClose}
                    />
                </div>
                <div style={{ width: "300px", padding: "20px", pointerEvents: files.length === 1 ? "none" : "visible" }}>
                    <DropZone outline={true} onDrop={handleDropZoneDrop}>


                        {uploadedFiles}
                        {fileUpload}



                    </DropZone>
                </div>
                {files.length > 0 && (<div style={{
                    paddingTop: " 20px",
                    textAlignLast: "center"
                }}>
                   {loading ? (
                        <div className="container" style={{paddingLeft:"130px"}}>
                            <Spinner size='small'></Spinner>
                        </div>
                    ) : (
                        <button
                            style={{
                                border: '1px solid grey', // Grey border
                                borderRadius: '4px', // Rectangle border
                                padding: '10px 20px', // Adjust padding as needed
                                backgroundColor: 'transparent', // Transparent background
                                color: '#333', // Text color
                                cursor: 'pointer', // Show pointer cursor on hover
                                outline: 'none', // Remove default button outline
                            }}
                            onClick={handleSaveIconClick} // Call handleSaveIconClick when the button is clicked
                        >
                            Save Icon
                        </button>
                    
            )}
                </div>)}
            </div>

        </Modal>
    );
};

// Define PropTypes for the component
interface DevUploadIconProps {
    open: boolean;
    onClose: () => void;
    // Add any other props you need
}

export default DevUploadIcon;
